<template>
  <v-container id="login" class="fill-height justify-center" tag="section">
    <v-row justify="center">
      <v-slide-y-transition appear>
        <base-material-card icon="mdi-login" color="accent">
          <template v-slot:after-heading>
            <div class="font-weight-light card-title">Welcome, sign in to School 360 Online SIMS</div>
          </template>

          <v-card-text class="text-center">
            <validation-observer v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(validateForm)">
                <validation-provider v-slot="{ errors }" name="email" rules="required|email">
                  <v-text-field
                    v-model="email"
                    :error-messages="errors"
                    color="secondary"
                    type="email"
                    label="Email..."
                    prepend-icon="mdi-email"
                    class="mt-10"
                  />
                </validation-provider>

                <validation-provider v-slot="{ errors }" name="password" rules="required">
                  <v-text-field
                    v-model="password"
                    class="mb-8"
                    label="Password*"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show ? 'text' : 'password'"
                    color="secondary"
                    @click:append.prevent="show = !show"
                    prepend-icon="mdi-lock-outline"
                    :error-messages="errors"
                  />
                </validation-provider>

                <pages-btn
                  href="/pages/resetpassword"
                  large
                  color
                  depressed
                  class="v-btn--text text-capitalize font-weight-bold"
                >Forgot Your Password?</pages-btn>

                <v-btn
                  color="primary"
                  default
                  large
                  block
                  rounded
                  class="text-capitalize font-weight-bold mt-5"
                  type="submit"
                  :disabled="loading"
                  :loading="loading"
                >Let's Go! Verify My Credentials</v-btn>
              </form>
            </validation-observer>
          </v-card-text>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "PagesLogin",

  components: {
    PagesBtn: () => import("./components/Btn")
  },
  $_veeValidate: {
    validator: "new"
  },
  data: () => ({
    email: "",
    password: "",
    show: false,
    loading: false,
    errorMessage: null
  }),
  computed: {    
    showError() {
      return this.errorMessage !== null && this.errorMessage.length > 0;
    }
  },  
  methods: {
    clearForm() {
      // this.$v.$reset();
      this.email = null;
      this.password = null;
    },
    validateForm(scope) {
      this.loading = true;
      this.errorMessage = null;

      this.$store
        .dispatch("authenticationService/signIn", {
          email: this.email,
          password: this.password
        })
        .then(() => {
          this.loading = false;
          this.$router.push("/user");
        })
        .catch(error => {
          this.loading = false;
          this.errorMessage = error.message;
        });
    }
  }
};
</script>
